'use client';

import {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useContext,
  useMemo,
  useState
} from 'react';
import { MergedPriceAndAvailabilityResponse } from 'services/dealerPriceAvailability/types';
import { CartResponse } from 'services/cart/types';

type AlternateContextProviderProps = {
  children: ReactNode;
};
type AlternateContextType = {
  priceAndAvailability: MergedPriceAndAvailabilityResponse[];
  setPriceAndAvailability: Dispatch<
    SetStateAction<MergedPriceAndAvailabilityResponse[]>
  >;
  cartDetails: CartResponse;
  setCartDetails: Dispatch<SetStateAction<CartResponse>>;
};

export const AlternateContext = createContext<AlternateContextType>(null);

export const AlternateContextProvider = ({
  children
}: AlternateContextProviderProps) => {
  const [priceAndAvailability, setPriceAndAvailability] = useState<
    MergedPriceAndAvailabilityResponse[]
  >([]);
  const [cartDetails, setCartDetails] = useState<CartResponse>(null);

  const contextValues = useMemo(
    () => ({
      priceAndAvailability,
      setPriceAndAvailability,
      cartDetails,
      setCartDetails
    }),
    [priceAndAvailability, cartDetails]
  );

  return (
    <AlternateContext.Provider value={contextValues}>
      {children}
    </AlternateContext.Provider>
  );
};

export const useAlternateContext = () => useContext(AlternateContext);
